import React from 'react';
import { motion } from 'framer-motion';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  onClick,
  disabled = false,
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-inter font-medium rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 border border-transparent';
  
  const variants = {
    primary: 'bg-[#5f7561] text-white hover:bg-[#4a5d4c] focus:ring-[#5f7561] shadow-sm hover:shadow-md',
    secondary: 'bg-white text-sage-500 border-sage-200 hover:bg-sage-50 focus:ring-sage-500 shadow-sm hover:shadow-md',
    outline: 'bg-transparent text-gray-700 border-gray-300 hover:bg-gray-50 focus:ring-gray-400 hover:border-gray-400',
  };

  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-2.5 text-sm',
    lg: 'px-8 py-3 text-base',
  };

  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer';

  return (
    <motion.button
      whileHover={!disabled ? { scale: 1.02 } : {}}
      whileTap={!disabled ? { scale: 0.98 } : {}}
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${disabledClasses} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default Button;